import React from 'react'
import './ShowingResultsCount.scss'

const ShowingResultsCount = ({ lexicon, total, num1, num2 }) => (
  <h6 className="ShowingResultsCount">
    {lexicon.get('showing_results', {
      total_num: total,
      num1,
      num2,
    })}
  </h6>
)

export default ShowingResultsCount
